import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SessionContext } from '@contexts';
import { helpers, Enums } from "@shared";
import { sunboundPayProxy } from '@proxies';

const useSession = () => {
    const [session, setSession] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [sesisonData, setSessionData] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [showAccountSelector, setShowAccountSelector] = useState(true);

    const initSession = (session) => {

        setSession(session);
        if (session != null && session.accounts) {
            let idAccount = null, residentName = null;
            const {
                accounts,
                payorPreferences: { selectedAccount: prefSelectedAccount = null }
            } = session;

            idAccount = selectedAccount?.idAccount ?? prefSelectedAccount ?? null;

            const foundAccount = idAccount && accounts.find(a => a.idAccount === idAccount);
            if (!foundAccount) {
                // in the absence of a selected account:
                // - assumes there is always at least one account
                // - prefers the earliest created account
                const sortedAccounts = [...accounts].sort((a, b) => a.createdAt - b.createdAt);
                const firstAccount = sortedAccounts[0];

                ({ idAccount, residentName } = firstAccount);
            } else {
                ({ idAccount, residentName } = foundAccount);
            }

            setSelectedAccount({ idAccount, residentName });
            setSession(session);
            setSessionData(helpers.sessionData(session, idAccount));

            setAccounts(accounts);
        }
    };

    const changeSelectedResident = async (idAccount, navigate = null) => {
        const acc = helpers.sessionData(session, idAccount);
        const { residentName } = acc;
        setSessionData(acc);
        setSelectedAccount({ idAccount, residentName });

        navigate(`/`);

        try {
            await sunboundPayProxy.updatePayorPreferences(Enums.Preference.selectedAccount, idAccount);
        } catch (error) {
            console.log(error);
        }
    };

    const logout = () => {
        setSelectedAccount(null);
        setSession(null);
        setSessionData(null);
        setAccounts([]);
    };

    return {
        rawSession: session,
        session: sesisonData,
        accounts,
        setSession: initSession,
        selectedAccount,
        changeSelectedResident,
        logout,
        showAccountSelector,
        setShowAccountSelector
    };
};

function SessionProvider({ children }) {
    const value = useSession();
    return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export default SessionProvider;

SessionProvider.propTypes = {
    children: PropTypes.node.isRequired
};
